import React from 'react'
import { useNavigate } from 'react-router-dom'
import { AddMoney, Copy, Flights, Rewards, Watch } from '../../../assests/ExportImageIcon'
import './offerCashback.css'

const STATS = [
    { value: '6', label: 'Active Offers' },
    { value: '₹3.5K', label: 'Max Savings' },
    { value: '₹1.2K', label: 'Earned' },
]

const OFFERS = [
    { icon: AddMoney, title: 'Wallet Top-up Bonus', desc: 'Get ₹100 cashback on adding ₹2000 or more', amount: '₹100', code: 'WALLET100', validTill: 'Mar 31,2026' },
    { icon: Flights, title: 'Flight Booking Cashback', desc: 'Save 10% up to ₹1500 on domestic flights', amount: '₹100', code: 'WALLET100', validTill: 'Mar 31,2026' },
]

const HOW_IT_WORKS = [
    'Apply offer code at checkout',
    'Complete your booking payment',
    'Cashback credited within 24-48 hours',
    'Use cashback for future bookings',
]

const BackArrow = () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
        <path d="M15 9H4M8 5l-4 4 4 4" stroke="#026D4D" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

const OfferCashback = () => {
    const navigate = useNavigate()

    return (
        <section className='commonTopPadding commonBottomPadding'>
            <div className='container'>
                <div className='row g-4'>
                    <div className='col-md-12'>
                        <div className='offerCashbackHead commonMaxWidth'>
                            <div className='tripDocHeader justify-content-between' onClick={() => navigate(-1)}>
                                <div className='d-flex align-items-center gap-2'>
                                    <BackArrow />
                                    <span className='bsSectionTitle'>Offers &amp; Cashback</span>
                                </div>
                                <span
                                    className='offerTxnHistoryLink'
                                    onClick={(e) => { e.stopPropagation(); navigate('/my-transaction') }}
                                >
                                    <img src={Watch} alt="" /> Transaction History
                                </span>
                            </div>
                            
                        </div>
                    </div>

                    <div className='col-md-12'>                       

                        <div className='cashbackData'>
                            <div className='offerStatsRow'>
                            {STATS.map((stat, index) => (
                                <div className='offerStatCard' key={index}>
                                    <div className='offerStatCard__value'>{stat.value}</div>
                                    <div className='offerStatCard__label'>{stat.label}</div>
                                </div>
                            ))}
                        </div>
                            <div className='offerPowerWeek bgWhite commonBorder borderRadius20 paddingCommon20 mt-4'>
                                <div className='offerPowerWeek__left'>
                                    <img src={Rewards} alt="" />
                                    <div>
                                        <div className='offerPowerWeek__title'>Wallet Power Week!</div>
                                        <div className='offerPowerWeek__subtitle'>Add money to wallet this week and unlock exclusive bonuses!</div>
                                    </div>
                                </div>
                                <button type='button' className='travellerAddBtn offerAddMoneyBtn' onClick={() => navigate('/add-money')}>Add Money Now</button>
                            </div>

                            <div className='mt-4'>
                                <div className='bsSectionTitle'>All Offers</div>
                                <div className='offerGrid'>
                                    {OFFERS.map((offer, index) => (
                                        <div className='offerCard bgWhite commonBorder borderRadius20 paddingCommon20' key={index}>
                                            <div className='offerCard__top'>
                                                <img src={offer.icon} alt="" />
                                                <div className='offerCard__info'>
                                                    <div className='offerCard__title'>{offer.title}</div>
                                                    <div className='offerCard__desc'>{offer.desc}</div>
                                                </div>
                                                <span className='offerCard__amount'>{offer.amount}</span>
                                            </div>

                                            <div className='offerCodeBox'>
                                                <span>{offer.code}</span>
                                                <button type='button' className='offerCodeBox__copy' aria-label="Copy code">
                                                    <img src={Copy} alt="" />
                                                </button>
                                            </div>

                                            <div className='offerCard__bottom'>
                                                <span className='offerCard__validity'>Valid till {offer.validTill}</span>
                                                <span className='offerCard__viewDetails'>View Details</span>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                                
                            <div className='mt-4'>
                                <div className='bsSectionTitle'>How Cashback Works</div>
                                <div className='bsBox'>
                                    <ul className='bsInfoList'>
                                        {HOW_IT_WORKS.map((step, index) => (
                                            <li key={index}>{step}</li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    )
}

export default OfferCashback
